export const DEFAULT_IMAGE_OPTIONS = {
  allowedExtensions: ['.jpg', '.jpeg', '.png'],
  allowedMimeTypes: ['image/jpg', 'image/jpeg', 'image/png'],
  maxSizeMB: 5,
}

const normalizeOptions = (options = {}) => ({
  ...DEFAULT_IMAGE_OPTIONS,
  ...options,
})

export const isAllowedImageFile = (file, options = {}) => {
  if (!file) return false

  const { allowedExtensions, allowedMimeTypes } = normalizeOptions(options)
  const normalizedName = file.name?.toLowerCase?.() || ''

  return (
    allowedMimeTypes.includes(file.type) ||
    allowedExtensions.some((extension) =>
      normalizedName.endsWith(extension)
    )
  )
}

export const getImageFilesValidationError = (files = [], options = {}) => {
  const { allowedExtensions, allowedMimeTypes, maxSizeMB } =
    normalizeOptions(options)
  const maxSizeBytes = maxSizeMB * 1024 * 1024
  const normalizedFiles = Array.from(files || [])

  if (!normalizedFiles.length) return null

  if (
    normalizedFiles.some(
      (file) =>
        !isAllowedImageFile(file, { allowedExtensions, allowedMimeTypes })
    )
  ) {
    return `Only ${allowedExtensions.join(', ')} files are allowed.`
  }

  if (normalizedFiles.some((file) => file.size > maxSizeBytes)) {
    return `Image size too large. Please choose images ${maxSizeMB} MB or smaller.`
  }

  return null
}